/* 3D / 360° preview in the product page gallery (snippet wu-3d-tile): the iframe is inserted only after a click on the slide or its thumbnail. */
if (!customElements.get('wu-3d-media')) {
  customElements.define('wu-3d-media', class extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', () => this.load());
      this._onThumb = (e) => {
        const t = e.target.closest('[data-media-id]');
        if (t && t !== this && t.dataset.mediaId === this.dataset.mediaId) this.load();
      };
      document.addEventListener('click', this._onThumb);
    }
    disconnectedCallback() { document.removeEventListener('click', this._onThumb); }
    load() {
      if (this.dataset.loaded) return;
      const tpl = this.querySelector('template');
      if (!tpl) return;
      this.dataset.loaded = '1';
      const play = this.querySelector('.wu-3d-media__play');
      const hadFocus = play && play.contains(document.activeElement);
      this.appendChild(tpl.content.cloneNode(true));
      play?.remove();
      if (hadFocus) this.querySelector('iframe')?.focus();
      this.querySelector('.wu-3d-media__poster')?.remove();
    }
  });
}
